import { createContext, useContext, useState } from "react";
const PurchaseContext = createContext(null);

export const PurchaseProvider = ({ children }) => {
  const [purchaseDetails, setPurchaseDetails] = useState({});

  const value = {
    purchaseDetails,
    setPurchaseDetails,
  };

  return (
    <PurchaseContext.Provider value={value}>
      {children}
    </PurchaseContext.Provider>
  );
};

export const usePurchases = () => {
  return useContext(PurchaseContext);
};
